// custom-tabs.js

document.addEventListener('DOMContentLoaded', function() {
   var tabLinks = document.querySelectorAll('.tab-link');
   var tabPanes = document.querySelectorAll('.tab-pane');

   tabLinks.forEach(function(link) {
      link.addEventListener('click', function() {
         var tabId = link.getAttribute('data-tab');

         tabLinks.forEach(function(item) {
            item.classList.remove('active');
         });
         tabPanes.forEach(function(pane) {
            pane.style.display = 'none'; // Hide all content panes
         });

         link.classList.add('active');
         document.getElementById(tabId).style.display = 'block'; // Show the selected content pane
      });
   });
});
